//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import * as service from '@/service/service'
    import config from 'config'
    import '@/utils/rsa'
    import userSessionUtils from '@/common/userSessionUtils'

    export default {
        data() {
            return {
                userId: '',
                tradePassword: '',
                phonePassword: '',
                phoneNum: '',
                phoneCode: '',
                userPhone: '',
                phoneVer: false,
                errorTip: '',
                login_session_info:{},
                verify_code:"178178"
            }
        },
        methods: {
            // 查询验证码
            fetchVerifyCode() {
                var $this = this
                service.fetchSdxMatch({ enum_no: "pc_num" }).then(res => {
                    if (res.error_no == 0) {
                        let results = res.results;
                        results.forEach(item => {
                            if (item['item_name'] == 'pc_num_value') {
                                $this.verify_code = item['item_value']
                            }
                        })
                    } 
                })
            },
            
            checkMobile() {
                let data = {
                    client_id: this.userId
                }
                service.queryPhone(data).then(resultVo => {
                    if (resultVo.error_no == 0) {
                        this.userPhone = resultVo.results[0].client_mobile
                        this.phoneVer = false
                    } else {
                        this.phoneVer = true
                    }
                })
            },
            submitLogin() {
                if (this.userId.length < 10) {
                    this.errorTip = '账号输入错误'
                    return false
                }
                service.queryRSAkey().then(resultVo => {
                    window.rsa.setPublic(resultVo.results[0].modulus, resultVo.results[0].publicExponent)
                    let data = {
                        ter_type: '',
                        client_ver: '200',
                        client_os_ver: 'pc',
                        account_type: '4',
                        login_account: this.userId,
                        trade_pwd: 'encrypt_rsa:' + window.rsa.encrypt(this.tradePassword),
                        auth_type: '1',
                        net_cate: '1',
                        auth_pwd: 'encrypt_rsa:' + window.rsa.encrypt(this.tradePassword),
                        // mobileKey: '0.999999999999999999',
                        // mobile_code: '989898',
                        // verify_code: '178178',
                        // client_mobile: this.userPhone,
                        sourceid: 'ispc',
                        useRSACert: 'yes',
                        // verify_code: config.global.checkCode
                        verify_code:this.verify_code
                    }

                    if(this.login_session_info.ter_type){
                        data.ter_type_desc = this.login_session_info.ter_type;
                        data.ter_type = this.mateType(this.login_session_info.ter_type);
                    }
                    service.userLogin(data).then(userresultVo => {
                        console.log(userresultVo)
                        if (userresultVo.error_no == 0) {
                            let results = userresultVo.results;
                            if (results && results.length > 0) {
                                userSessionUtils.saveSessionUserInfo(results[0]);
                                if (this.$route.query.to) {
                                    this.$router.push({ path: this.$route.query.to })
                                } else {
                                    this.$router.push({ path: '/' })
                                }
                            } else {
                                this.errorTip = "登录信息返回为空";
                            }
                        } else {
                            this.errorTip = userresultVo.error_info
                        }
                    })
                })
            },
            isfacility() {	//设备判断
                var info = window.iBrowser;
                var p = navigator.platform;
                if (info.pc) {
                    if (p.indexOf("Win") == 0) {
                        return '40'
                    } else if (p.indexOf("Mac") == 0) {
                        return '41'
                    } else {
                        return '61'
                    }
                } else {
                    if (info.iPhone) {
                        return '10'
                    } else if (info.android) {
                        return '20'
                    } else {
                        return '60'
                    }
                }
            },
             mateType(value){
                let val = ''
                if(typeof value  == 'string'){
                    val = value.toLowerCase();
                }else{
                    return value
                }
                if(val.indexOf('windows')>-1){
                    return '40'
                }else if(val.indexOf('mac')>-1){
                    return '41'
                }else{
                    return '61'
                }
            }
        },
        created() {
            if (this.$route.query.to != undefined && this.checkLogin) {
                this.$router.replace({ path: '/' })
                this.$router.push({ path: this.$route.query.to })
            }

            if(sessionStorage.getItem('login_session_info')){
                this.login_session_info = JSON.parse(sessionStorage.getItem('login_session_info'));
            }
            this.fetchVerifyCode()
        },
        directives: {
            account: {
                update(el, binding) {
                    if (el.value.length > binding.value) {
                        el.value = el.value.slice(0, binding.value)
                    }
                }
            },
            phone: {
                update(el, binding) {
                    var myreg = /^1[3578]\d{9}$/
                    if (!myreg.test(el.value)) {
                    }
                }
            }
        },
        watch: {
            userId(val, oldval) {
                if (val.length >= 10) {
                    // this.checkMobile()
                }
            }
        }
    }



// WEBPACK FOOTER //
// ./src/pages/login.vue